module.exports = function (form) {
    var $form = form.getFormElem();
    var initValues = {};
    
    if ('utm_source' in window.utmValues) {
        initValues['icfi_utm_source'] = window.utmValues['utm_source'];
    }

    if ('utm_source' in window.utmValues) {
        initValues['icfi_utm_medium'] = window.utmValues['utm_medium'];
    }

    if ('utm_campaign' in window.utmValues) {
        initValues['icfi_utm_campaign'] = window.utmValues['utm_campaign'];
    }

    if ('utm_content' in window.utmValues) {
        initValues['icfi_utm_content'] = window.utmValues['utm_content'];
    }

    if ('utm_term' in window.utmValues) {
        initValues['icfi_utm_term'] = window.utmValues['utm_term'];
    }

    form.setValues(initValues);
};